import { ProfessionRepository } from "../repositories/Profession.repository";

export const ProfessionService = {
    getProfessions,
}

async function getProfessions(){
    const res = await ProfessionRepository.getProfessions();
    return res;
}